/** Servicios clínicos soportados por la validación IA de certificados. */
export type CertificationServiceCode =
  | 'COUPLE_THERAPY'
  | 'FAMILY_THERAPY'
  | 'VOCATIONAL_COUNSELING';

export type CertificationValidationStatus =
  | 'approved'
  | 'needs_additional_document'
  | 'rejected_escalated';

/** Respuesta del endpoint de validación IA en psiplatform-be (POST /api/psychologist/certification-validation). */
export interface CertificationValidationResult {
  status: CertificationValidationStatus;
  service: CertificationServiceCode;
  attempt: 1 | 2 | 3;
  /** Explicación interna — no se muestra tal cual a la psicóloga. */
  matchReasoning: string;
  /** Texto corto para la psicóloga. null si approved. */
  userFeedback: string | null;
}

/** Nombre UI (tag de "Sobre tu atención") -> código de servicio que espera el system prompt. */
export const CERTIFICATION_SERVICE_CODE_BY_NAME: Record<string, CertificationServiceCode> = {
  Pareja: 'COUPLE_THERAPY',
  Familia: 'FAMILY_THERAPY',
  'Orientación vocacional': 'VOCATIONAL_COUNSELING',
};
